const SET_OPENED = 'SET_OPENED'
const SET_ROUTE = 'SET_ROUTE'

export default {
  namespaced: true,

  state: {
    route: '',
    opened: false
  },

  actions: {
    setOpened({
      commit
    }, payload) {
      commit('SET_OPENED', payload)
    },

    setRoute({
      commit
    }, payload) {
      commit('SET_ROUTE', payload)
    }
  },

  mutations: {
    [SET_OPENED](state, payload) {
      state.opened = payload
    },

    [SET_ROUTE](state, payload) {
      state.route = payload
    }
  },

  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js